export default {
  SET_BLH (state, blh) {
    state.blh = blh
  },
  SET_PROCESS (state, proc) {
    state.certificationProcess = proc
  },
  SET_EQUIPMENT_LIST (state, _equipmentList) {
    state.equipmentList = _equipmentList
  },
  LOGIN: state => {
    state.pending = true
  },
  LOGIN_SUCCESS: (state, uid) => {
    state.uid = uid
    state.pending = false
  },
  LOGOUT: state => {
    state.uid = null
    state.blh = null
    state.certificationProcess = null
  },
  GOTO_STEP: (state, stepIndex) => {
    state.step = stepIndex
  },
  SET_STEP: (state, status) => {
    if (status < 4) {
      state.step = 0
    } else if (status < 5) {
      state.step = 1
    } else if (status < 6) {
      state.step = 2
    } else {
      state.step = 3
    }
  },
  SET_CURRENT_PHOTO_AREA: (state, areaIndex) => {
    console.log('SET_CURRENT_PHOTO_AREA' + areaIndex)
    state.currPhotoArea = areaIndex
  },
  SET_CURRENT_PHOTO_TYPE: (state, type) => {
    state.currPhotoType = type
  },
  SET_AREAS_LIST (state, _areasList) {
    state.areasList = _areasList
  },
  SET_CONTINUE_WITH_MINIMUM: (state) => {
    state.continueWithMinimum = true
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js